import { SidebarView } from "../../../../types/SidebarView";
import { LayoutActionKey } from "../../../actions/ActionKeys";
import { LayoutAction } from "../../../actions/layout";

export const sidebarView = (
  state: SidebarView = SidebarView.NOTEBOOK,
  action: LayoutAction
): SidebarView => {
  switch (action.type) {
    case LayoutActionKey.SET_SIDEBAR_VIEW:
      return action.payload.sidebarView;
    default:
      return state;
  }
};
